import axios from 'axios';
import { put, get, deleteRequest } from 'helpers/api';
import type { DocumentDefaultsType } from './types';

type SaveFormDataOptions = {
  propagateToChildren?: boolean
};

export function saveFormData(
  path : string,
  documentDefaults : Partial<DocumentDefaultsType>,
  options? : SaveFormDataOptions
) {
  const propagateToChildren = options?.propagateToChildren || false;
  const payload = { documentDefaults };

  if (propagateToChildren) payload['propagate_to_children'] = true;

  return put(path, payload);
}

export type UploadedPdfTemplate = {
  id: number;
  name: string;
  size: string;
  user_label: string;
  template_type: string;
};

type UploadPdfResponse = {
  templates: UploadedPdfTemplate[];
};

export async function uploadPdfTemplates(basePath: string, files: File[]): Promise<UploadedPdfTemplate[]> {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('pdfs[]', file);
  });

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

  const response = await axios.post<UploadPdfResponse>(`${basePath}/upload_pdf`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-CSRF-TOKEN': csrfToken
    }
  });

  return response.data.templates;
}

export type PdfTemplateUsage = {
  documentOptionsId: number;
  parentName: string;
  parentType: string;
  documentTemplateName: string;
  inPageLibrary: boolean;
  inDefaultPages: boolean;
};

export async function getPdfTemplateUsages(basePath: string, templateId: number): Promise<PdfTemplateUsage[]> {
  const response = await get(`${basePath}/pdf_usages`, { params: { pdfTemplateId: templateId } });
  return response.usages;
}

export async function deletePdfTemplate(basePath: string, templateId: number): Promise<void> {
  await deleteRequest(`${basePath}/delete_pdf`, { params: { pdfTemplateId: templateId } });
}
